module.exports = __webpack_public_path__ + "media/images/icon-svg/facebook-c2e68a4878d17ce0cfc3a0763acf4f69.svg";